import React from 'react';
import * as people from '../data/people.js';

function QuoteGuessBoxes({ correctAuthor, guess, allGuesses }) {
  if (guess !== null) {
    const isCorrect = guess.toLowerCase() === correctAuthor.toLowerCase();

    return (
      <div className="flex items-stretch justify-center gap-3">
        <div
          className={`box ${isCorrect ? 'correct' : 'blank'} flex h-auto w-32 flex-col items-center justify-center px-2 text-sm font-semibold sm:w-40 sm:text-base lg:text-lg`}
        >
          {guess}
        </div>
      </div>
    );
  }

  return <></>;
}

export default QuoteGuessBoxes;
